<template>
    <page>
        <module>
            <view-list ref="view" :work-type="workType" selector :view-config="saasInfo.viewmanage" @change="getType">
                <template #search>
                    <m-search ref="search" :extend-data="defaultSearchData">
                        <m-search-item label="提现单号">
                            <c-input name="apply_no"></c-input>
                        </m-search-item>
                        <m-search-item label="提现申请人" v-if="userIdentity!=3">
                            <c-input name="user_realname"></c-input>
                        </m-search-item>
                        <m-search-item label="提现申请人" v-if="userIdentity==3">
                            <c-input name="platform_user_nickname"></c-input>
                        </m-search-item>
                    </m-search>
                </template>

                <template #operate>
                    <c-button v-if="auth('b_withdraw_apply_audit')" color="main" @click="withdrawAdit">批量审批</c-button>
<!--                    <c-button v-if="auth('b_withdraw_apply_pay')" color="green" @click="withdrawCheckPay">批量打款</c-button>-->
                    <c-button v-if="auth('b_withdraw_apply_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
                </template>
                <!--提现状态-->
                <template #withdraw_status="{data}">
                    <c-state tag async dict="WITHDRAW_STATUS" :value="data.withdraw_status"></c-state>
                </template>
                <!--提现打款方式-->
                <template #withdraw_pay_type="{data}">
                    <c-state v-if="data.withdraw_pay_type == 0" tag async dict="WITHDRAW_PAY_TYPE" :value="data.withdraw_pay_type"></c-state>
                    <c-state v-else-if="data.withdraw_pay_type == 1" tag async dict="WITHDRAW_PAY_TYPE" :value="data.withdraw_pay_type"></c-state>
                    <span v-else>-</span>
                </template>
                <!--提现用户身份-->
                <template #user_realname="{data}">
                    <span>{{data.user_realname}}</span>
                    <span v-if="data.user_identity == 2">({{data.supplier_name}})</span>
                    <span v-if="data.is_sign_contract == 1" style="color: green">[已签约]</span>
                    <span v-else style="color: #F56C6C">[未签约]</span>
                </template>
                <!--提现用户身份-->
                <template #user_identity="{data}">
                    <c-state tag dict="USER_IDENTITY" :value="data.user_identity"></c-state>
                </template>
                <!--提现账号-->
                <template #withdraw_account="{data}">
                    <span>【{{data.bank_name}}】</span>
                    <span>{{data.bank_card_no}}</span>
                </template>
                <!--提现金额-->
                <template #withdraw_amount="{data}">
                    ￥{{data.withdraw_amount}}
                </template>
                <!--服务费-->
                <template #withdraw_fee="{data}">
                    <span v-if="data.withdraw_fee && data.withdraw_fee > 0" style="color: red">￥{{data.withdraw_fee}}</span>
                    <span v-else>￥{{data.withdraw_fee}}</span>
                </template>
                <!--预计到账-->
                <template #arrival_amount="{data}">
                    <span v-if="data.arrival_amount && data.arrival_amount > 0" style="color: green">￥{{data.arrival_amount}}</span>
                    <span v-else>￥{{data.arrival_amount}}</span>
                </template>

                <c-table-column
                        type="button"
                        label="操作"
                        width="110"
                        button-limit="6"
                >
                    <template #default="{data}">
                        <c-table-button icon="tf-detail" @click="globalDialog('withdrawApplyDetail', {props: {id: data.id}})">查看</c-table-button>
                        <c-table-button v-if="auth('b_withdraw_apply_audit')" :disabled="data.withdraw_status != 1" icon="tf-approve" @click="withdrawAdit(data)">审批</c-table-button>
                    </template>
                </c-table-column>
            </view-list>
            <!--提现审批弹窗-->
            <withdraw-audit ref="withdrawAudit" @resolve="$refs.view.update()"></withdraw-audit>
        </module>
    </page>
</template>

<script>
import {mapState} from 'vuex'
import withdrawAudit from "@/pages/finance/withdraw_audit.vue";

export default {
    components: {
        withdrawAudit
    },

    data() {
        return {
            workType: 103,
            defaultSearchData: {
                withdraw_user_type: 2     //提现用户类型：2=子账号
            },
            balance:0,
            payEnabled:true,
            ids:[],
            userIdentity:1,              //提现用户身份 1=子账号 2=供应商联系人 3=平台会员
        }
    },

    computed: {
        // 获取dictName选项数据
        ...mapState(['saasInfo'])
    },

    methods: {
        /*******获取视图特殊过滤字段*****************/
        getType(viewId) {
            this.request({
                url: '/sys_user_view/user_identity/filte',
                data: {
                    view_id: viewId
                },
                success: data => {
                    this.userIdentity = data||1;
                }
            })
        },
        //提现申请审批
        withdrawAdit(data) {
            let flag = true;
            var ids = [];
            var signContract = true;         //提现申请人是否已签约（批量审批时需全部已签约）
            if (data){
                ids.push(data.id);
                signContract = data.is_sign_contract == 1;
            }else {
                this.$refs.view.$refs.list.getData('selected').forEach(item => {
                    if (item.withdraw_status != 1){
                        this.$message({
                            message: '请选择“待审批”的提现记录进行操作',  // 提示内容,
                            type: 'warn'
                        });
                        flag = false;
                    }
                    if (item.is_sign_contract != 1){
                        signContract = false;
                    }
                    ids.push(item.id);
                });
                if (!ids || ids.length == 0){
                    this.$message({
                        message: '请至少选择一条提现吗申请数据进行操作',  // 提示内容,
                        type: 'warn'
                    });
                    flag = false;
                }
            }
            if (flag){
                this.$refs.withdrawAudit.open(ids, signContract);
            }
        },
        //提现申请打款-校验信息
        withdrawCheckPay() {
            this.ids = [];
            this.payEnabled = true;
            //查询今日剩余打款次数
            let flag = true;
            let total_amount = 0;
            var selected_list = this.$refs.view.$refs.list.getData('selected');
            selected_list.forEach(item => {
                if (item.withdraw_status != 2){
                    this.$message({
                        message: '请选择“待打款”的提现记录进行操作',  // 提示内容,
                        type: 'warn'
                    });
                    flag = false;
                    return
                }
                total_amount = total_amount + item.withdraw_amount||0;
                this.ids.push(item.id);
            });

            let hasType1 = false
            let hasType2 = false

            selected_list.forEach(item => {
                // 已经找到两种，后续不再执行判断
                if (hasType1 && hasType2) return

                if (item.withdraw_account_type === 1) hasType1 = true;
                if (item.withdraw_account_type === 2) hasType2 = true;
            })

            if (hasType1 && hasType2) {
                this.$message({
                    message: '请选择相同“账户类型”的提现记录进行操作',  // 提示内容,
                    type: 'warn'
                });
                flag = false;
                return
            }
            if (flag){
                this.applyAmount = total_amount;
                //查询今日剩余打款次数
                this.request({
                    url: '/withdraw/check/payinfo',
                    loading: true,
                    data: {},
                    success: data => {
                        this.$refs.payForm.clear();
                        var apply_amount = "打款总额：¥" + total_amount;
                        if (data.balance < total_amount){
                            this.balance = data.balance;
                            this.payEnabled = false;
                        }
                        var remain_count = "今日已打款次数：" + data.used_count + "(剩余" + data.remain_count + "次)";
                        this.$refs.payForm.set({
                            ids: this.ids,
                            apply_amount:apply_amount,
                            remain_count: remain_count
                        });
                        this.$refs.payDialog.open();
                    }
                });
            }
        }
    }
}
</script>


<style lang="stylus" scoped>
.factory {
    border: 1px solid var(--unit-line);
    border-radius: 0 10px 10px 10px;
    border-top: none;
    padding: 26px;
    margin: 0 15px 15px;
    overflow: auto;
    background: #fff;

    &-tab {
        margin: 0 15px;

        >>> ul {
            padding-left: 0;
        }
    }

    &-logo {
        margin-right: 28px;

        &-image {
            position: relative;
            width: 100px;
            height: 100px;
            font-size: 24px;
            color: #ccc;
            background: #242738;

            &:hover {
                color: var(--color-main);

                .factory-logo-handle {
                    display: flex;
                }
            }
        }

        &-handle {
            gap: 20px;
            display: none;
            position: absolute;
            inset: 0;
            font-size: 20px;
            color: #fff;
            background: rgba(0,0,0,.6);

            a {
                font-size: 20px;

                &:hover {
                    color: var(--color-main);
                }
            }
        }

        &-name {
            gap: 5px;
            margin-top: 10px;
            font-size: 13px;
            color: #666;
        }
    }

    &-name {
        height: 32px;
        gap: 12px;

        p {
            font-size: 22px;
            font-weight: bold;
        }

        a {
            font-size: 20px;
            color: var(--color-main);
        }

        input {
            box-sizing: border-box;
            width: 200px;
            height: 100%;
            border: 1px solid #ccc;
            padding: 0 10px;

            &:focus {
                border-color: var(--color-main);
            }
        }

        >>> .c-button {
            height: 32px !important;
        }
    }

    &-code {
        display: inline-block;
        border: 1px solid #ddd;
        border-radius: 15px;
        padding: 0 16px;
        margin-top: 10px;
        line-height: 28px;
        font-size: 14px;
    }

    &-info {
        margin-top: 34px;

        td {
            height: 36px;
            font-size: 14px;

            &:nth-child(1) {
                color: #666;
            }

            &:nth-child(2) {
                padding-left: 20px;
            }

            .edition {
                border-radius: 4px;
                padding: 0 8px;
                margin-right: 10px;
                line-height: 24px;
                font-size: 13px;
                color: #fff;
                background: #F5F5F5;
            }

            .tag {
                border-radius: 4px;
                padding: 0 12px;
                margin: 0 10px;
                line-height: 26px;
                font-size: 15px;
                font-weight: bold;
                background: #F5F5F5;

                span {
                    color: var(--color-main);
                }
            }
        }
    }

    &-handle {
        gap: 20px;
        margin-top: 20px;

        >>> .c-button {
            border-radius: 4px;
        }
    }
}

.templet-list {
    gap: 20px;
    box-sizing: border-box;
    padding: 20px;

    .item {
        width: 300px;
        border-radius: 6px;
        overflow: hidden;
        background: #F9F9F9;
        transition: box-shadow .3s ease;

        &:hover {
            box-shadow: 0 0 10px 2px rgba(0,0,0,.1);
        }

        .cover {
            height: 200px;
            overflow: hidden;

            .image {
                height: 100%;
                background-size: cover;
                background-position: center;
                transition: transform .3s ease;

                ^[-2]:hover ^[-2..-1] {
                transform: scale(1.2);
            }
            }
        }

        .info {
            padding: 6px 25px 0;

            h5 {
                line-height: 50px;
                font-size: 18px;
            }

            ul {
                li {
                    position: relative;
                    padding: 6px 0 6px 24px;
                    line-height: 20px;
                    font-size: 14px;
                    color: #666;

                    .tf {
                        position: absolute;
                        left: 0;
                        top: 0;
                        line-height: 32px;
                        font-size: 15px;
                        color: var(--color-main);
                    }
                }
            }
        }

        .button {
            padding: 16px 0 20px;

            >>> .c-button {
                width: 108px;
                height: 36px !important;
            }
        }
    }
}

.data-type {
    gap: 15px;
    padding: 20px;

    li {
        position: relative;
        border: 1px solid #F5F5F5;
        border-radius: 4px;
        padding: 20px;
        background: #F5F5F5;
        cursor: pointer;

        h5 {
            margin-bottom: 14px;
            font-size: 16px;
            font-weight: normal;
        }

        p {
            line-height: 22px;
        }

        &.z-crt,
        &:hover {
            border-color: var(--color-main);
            background: #fff;
        }

        &.z-crt {
            &:before {
                content: '';
                position: absolute;
                right: 0;
                top: 0;
                border-top: 24px solid var(--color-main);
                border-left: 28px solid rgba(0,0,0,0);
            }

            &:after {
                content: '\e63f';
                position: absolute;
                right: 2px;
                top: 2px;
                font-family: 'iconfont';
                font-size: 10px;
                color: #fff;
            }
        }
    }
}

.notice {
    &-delete {
        padding: 5px;
        font-size: 15px;
        color: #f00;

        &:hover {
            border-radius: 4px;
            background: #F5F5F5;
        }
    }

    &-temp {
        height: 520px;

        &-tip {
            margin-left: 20px;
        }
    }

    &-guide {
        align-self: flex-start;
        position: sticky;
        top: 0;
        padding: 26px 30px 20px;
        background: #FAFAFA;

        &-tip {
            margin-bottom: 12px;
            font-size: 13px;
            color: #f55;
        }

        &-arrow {
            position: relative;
            width: 60px;
            height: 1px;
            margin: 90px 16px 0;
            background: #999;

            &:after {
                content: '';
                position: absolute;
                right: 0;
                top: -5px;
                border-left: 10px solid #999;
                border-top: 5px solid rgba(0,0,0,0);
                border-bottom: 5px solid rgba(0,0,0,0);
            }
        }

        &-item {
            width: 180px;

            img {
                height: 180px;
            }

            p {
                margin: 14px 0 10px;
                font-size: 14px;
                font-weight: bold;
                white-space: nowrap;
                color: #f55;
            }

            span {
                line-height: 20px;
                font-size: 13px;
                color: #999;
            }
        }
    }
}
</style>